import React, { useState } from 'react';

const INITIAL_TASKS = [
  { id: 'T01', title: 'Deploy hotfix v2.3.1', priority: 'High', status: 'Pending', owner: 'Alice' },
  { id: 'T02', title: 'Write API documentation', priority: 'Medium', status: 'Pending', owner: 'Bob' },
  { id: 'T03', title: 'Fix payment gateway bug', priority: 'High', status: 'Pending', owner: 'Carol' },
  { id: 'T04', title: 'Update onboarding flow', priority: 'Low', status: 'In Progress', owner: 'Dave' },
  { id: 'T05', title: 'Security audit review', priority: 'High', status: 'Pending', owner: 'Eve' },
  { id: 'T06', title: 'Database migration script', priority: 'High', status: 'Done', owner: 'Frank' },
  { id: 'T07', title: 'Redesign dashboard widgets', priority: 'Medium', status: 'In Progress', owner: 'Grace' },
  { id: 'T08', title: 'SSL certificate renewal', priority: 'High', status: 'In Progress', owner: 'Henry' },
  { id: 'T09', title: 'Load testing setup', priority: 'Low', status: 'Pending', owner: 'Iris' },
  { id: 'T10', title: 'Customer data export tool', priority: 'High', status: 'Done', owner: 'Jack' },
];

// High + Pending tasks: T01, T03, T05, T08, T10 = 5 tasks... but description says 3
// Let's make it exactly 3: T01, T03, T05
const HIGH_PENDING_IDS = ['T01', 'T03', 'T05'];
const EXPECTED_COUNT = 3;

export default function C06_GridBulk({ onComplete }) {
  const [tasks, setTasks] = useState(INITIAL_TASKS);
  const [selected, setSelected] = useState([]);
  const [confirmed, setConfirmed] = useState(false);
  const [markedCount, setMarkedCount] = useState(null);

  const toggleSelect = (id) => setSelected(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);
  const allSelected = tasks.length > 0 && tasks.every(t => selected.includes(t.id));
  const toggleAll = () => setSelected(allSelected ? [] : tasks.map(t => t.id));

  const markInProgress = () => {
    const count = selected.filter(id => {
      const t = tasks.find(x => x.id === id);
      return t && t.priority === 'High' && t.status === 'Pending';
    }).length;
    setTasks(prev => prev.map(t => selected.includes(t.id) ? { ...t, status: 'In Progress' } : t));
    setMarkedCount(count);
    setSelected([]);
  };

  const handleConfirm = () => {
    setConfirmed(true);
    const correctSelection = HIGH_PENDING_IDS.every(id => {
      const original = INITIAL_TASKS.find(t => t.id === id);
      const current = tasks.find(t => t.id === id);
      return current && current.status === 'In Progress';
    });
    const countCorrect = markedCount === EXPECTED_COUNT;
    const pass = correctSelection && countCorrect;
    onComplete({
      score: pass ? 100 : (correctSelection ? 50 : 0),
      details: {
        correctRowsUpdated: { expected: String(EXPECTED_COUNT), got: String(markedCount), pass: countCorrect },
        highPendingRowsChanged: { expected: 'T01,T03,T05', got: HIGH_PENDING_IDS.filter(id => tasks.find(t => t.id === id)?.status === 'In Progress').join(','), pass: correctSelection },
      },
      passed: pass,
    });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-toolbar">
        <span className="ab-row-count">{tasks.filter(t => t.priority === 'High' && t.status === 'Pending').length} High+Pending remaining</span>
        {selected.length > 0 && (
          <button className="ab-action-btn ab-action-btn-sm" onClick={markInProgress} disabled={confirmed}>
            Mark Selected as In Progress ({selected.length})
          </button>
        )}
      </div>

      <div className="ab-table-wrap">
      <table className="ab-table">
        <thead>
          <tr>
            <th><input type="checkbox" checked={allSelected} onChange={toggleAll} disabled={confirmed} /></th>
            <th>Task</th><th>Priority</th><th>Status</th><th>Owner</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map(t => (
            <tr key={t.id} className={selected.includes(t.id) ? 'ab-row-selected' : ''}>
              <td><input type="checkbox" checked={selected.includes(t.id)} onChange={() => toggleSelect(t.id)} disabled={confirmed} /></td>
              <td><strong>{t.title}</strong></td>
              <td><span className={`ab-badge ${t.priority === 'High' ? 'ab-badge-red' : t.priority === 'Medium' ? 'ab-badge-orange' : 'ab-badge-gray'}`}>{t.priority}</span></td>
              <td><span className={`ab-badge ${t.status === 'Done' ? 'ab-badge-green' : t.status === 'In Progress' ? 'ab-badge-blue' : 'ab-badge-gray'}`}>{t.status}</span></td>
              <td>{t.owner}</td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>

      {markedCount !== null && (
        <div className="ab-confirm-bar">
          <span className="ab-confirm-msg">
            {markedCount} High+Pending tasks were updated to "In Progress". Is this correct?
          </span>
          {!confirmed
            ? <button className="ab-action-btn" onClick={handleConfirm}>Confirm ({markedCount} updated)</button>
            : <div className="ab-submitted-badge">✓ Confirmed — Evaluating...</div>
          }
        </div>
      )}
    </div>
  );
}
